import { ReactComponent as PlusSvg } from '@/images/icons/plus.svg';
export default PlusSvg;
